import React from 'react';

const MessageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
    <path d="M24.305 0c.836 0 1.514.686 1.514 1.529v6.076c0 .844-.69 1.528-1.514 1.528h-6.14c-.835 0-1.513-.686-1.513-1.528V2.934l-1.597-1.796C14.496.51 14.726 0 15.56 0h8.745zm-3.062 6.47h-3.055v.913h3.055v-.914zM24.3 4.185h-6.111V5.1h6.11v-.913zm0-2.283h-6.111v.913h6.11v-.913z" transform="translate(-661 -676) translate(625 384) translate(10 57) translate(11.42 49.21) translate(0 176.772) translate(0 9.905)"/>
  </svg>
);

export default MessageIcon;
